import React from 'react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { Image } from 'antd'
import { Client } from '../../details'

type Props = {
  clientProfile: Client
}

export const DocumentsWidget: React.FC<Props> = ({ clientProfile }) => {
  return (
    <CCard>
      <CCardHeader>
        <strong>Documents</strong>
      </CCardHeader>
      <CCardBody>
        {clientProfile.verifications?.map((v) => {
          return v.browserFileNames.map((f) => {
            return (
              <div key={f}>
                <Image width={400} src={f} />
              </div>
            )
          })
        })}
        {clientProfile.verifications?.map((v) => {
          return v.browserFileNames.map((f, index) => {
            return (
              <a key={index} href={f} target="_blank">
                doc {index}
              </a>
            )
          })
        })}
      </CCardBody>
    </CCard>
  )
}
